export default __webpack_public_path__ + "static/media/1.0471d0bc.jpg";